export default "__VITE_ASSET__BJoUB8tg__"